import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { getAuthToken } from "../../lib/api/tokenStore";
import usePayouts from "./usePayouts";
import FinanceShell from "./components/FinanceShell";
import FilterChips from "./components/FilterChips";
import WithdrawalTable from "./components/WithdrawalTable";
import FinanceEmptyState from "./components/FinanceEmptyState";
import { TransactionRowsSkeleton } from "./components/FinanceSkeletons";
import { FINANCE_EMPTY_STATES } from "./financeCopy";
import { FINANCE_PATH, withdrawalDetailPath } from "./financeRoutes";

import "../checkout/styles.css";
import "./styles.css";

const FILTERS = [
  { id: "all", label: "All", status: undefined },
  { id: "paid", label: "Paid", status: "PAID" },
  { id: "pending", label: "Pending", status: "PENDING" },
  { id: "in-progress", label: "In Progress", status: "IN_PROGRESS" },
  { id: "rejected", label: "Rejected", status: "REJECTED" },
];

const WithdrawalsRoute = () => {
  const navigate = useNavigate();
  const enabled = Boolean(getAuthToken());

  const [filterId, setFilterId] = useState("all");
  const filter = FILTERS.find((row) => row.id === filterId) || FILTERS[0];
  const payouts = usePayouts({ status: filter.status, enabled });

  return (
    <FinanceShell
      title="Withdrawal Requests"
      backTo={FINANCE_PATH}
      showBack={false}
    >
      {(payouts.isLoading || payouts.isError || payouts.items.length > 0 || filterId !== "all") && (
        <FilterChips
          options={FILTERS.map(({ id, label }) => ({ id, label }))}
          activeId={filterId}
          label="Withdrawal status"
          onSelect={setFilterId}
        />
      )}

      {payouts.isLoading ? (
        <section className="sy-flow-card">
          <div className="sy-flow-card-body">
            <TransactionRowsSkeleton rows={6} />
          </div>
        </section>
      ) : payouts.isError ? (
        <FinanceEmptyState state={FINANCE_EMPTY_STATES.noWithdrawals} onRetry={payouts.refetch} />
      ) : payouts.items.length ? (
        <section className="sy-flow-card">
          <div className="sy-flow-card-body">
            <WithdrawalTable
              items={payouts.items}
              onSelect={(payout) => navigate(withdrawalDetailPath(payout.id))}
            />

            {payouts.canLoadMore && (
              <button
                type="button"
                className="sy-flow-btn sy-flow-btn-ghost fin-load-more"
                onClick={payouts.loadMore}
              >
                Load More
              </button>
            )}
          </div>
        </section>
      ) : (
        <FinanceEmptyState state={FINANCE_EMPTY_STATES.noWithdrawals} />
      )}
    </FinanceShell>
  );
};

export default WithdrawalsRoute;
